import React, { useState } from 'react';
import { microgreensData } from '../data/products';
import { useNavigate } from 'react-router-dom';
import './SubscriptionCustomization.css';

const SubscriptionCustomization = ({ addToCart }) => {
  const navigate = useNavigate();
  const [selectedItems, setSelectedItems] = useState([]);

  const handleProductSelect = (product) => {
    if (selectedItems.length < 2 || selectedItems.includes(product)) {
      const newSelection = selectedItems.includes(product)
        ? selectedItems.filter(item => item.id !== product.id)
        : [...selectedItems, product].slice(0, 2);
      setSelectedItems(newSelection);
    }
  };

  const calculateTotalPrice = () => {
    const basePrice = selectedItems.reduce((sum, item) => sum + item.price * 2, 0); // 2 oz packs
    const discountedPrice = basePrice * 0.90; // 10% discount
    return discountedPrice * 4; // 4 deliveries per month
  };

  const handleSubmit = () => {
    if (selectedItems.length === 2) {
      addToCart({
        id: 'custom-subscription',
        name: 'Weekly Microgreens Subscription',
        items: selectedItems,
        price: calculateTotalPrice(),
        isSubscription: true,
        frequency: 'weekly',
        deliveriesPerMonth: 4
      });
      navigate('/cart');
    }
  };

  return (
    <div className="container">
      <h1 className="title">Customize Your Weekly Subscription</h1>
      
      <div className="section">
        <h2 className="subtitle">Select 2 Microgreens</h2>
        <div className="product-grid">
          {microgreensData.filter(product => product.isAvailable).map(product => (
            <div 
              key={product.id}
              className={`product-card ${
                selectedItems.includes(product) ? 'selected' : ''
              }`}
              onClick={() => handleProductSelect(product)}
            >
              <h3 className="product-name">{product.name}</h3>
              <p className="product-description">{product.description}</p>
              <p className="product-price">${product.price.toFixed(2)*2} per pack (2 oz)</p>
            </div>
          ))}
        </div>
      </div>

      <div className="summary">
        <h2 className="subtitle">Subscription Summary</h2>
        <div className="summary-content">
          <p>Selected Items:</p>
          <ul className="selected-items">
            {selectedItems.map(item => (
              <li key={item.id}>{item.name}</li>
            ))}
          </ul>
          {selectedItems.length === 2 && (
            <div className="price-summary">
              <p className="delivery-info">
                4 deliveries per month (Every Wednesday)
              </p>
              <p className="total-price">
                Monthly Total: ${calculateTotalPrice().toFixed(2)}
              </p>
              <p className="discount-note">Includes 10% subscription discount</p>
            </div>
          )}
        </div>
      </div>

      <button
        onClick={handleSubmit}
        disabled={selectedItems.length !== 2}
        className={`submit-button ${selectedItems.length !== 2 ? 'disabled' : ''}`}
      >
        {selectedItems.length === 2
          ? 'Add Subscription to Cart'
          : `Select ${2 - selectedItems.length} more item${selectedItems.length === 1 ? '' : 's'}`}
      </button>
    </div>
  );
};

export default SubscriptionCustomization;